import request from '@/utils/request'

let Bill_riseApi = {

  /*发票抬头列表*/
  list(data) {
    return request._post('/shop/plus.bill_rise.Index/index', data);
},
/*添加发票抬头*/
add(data) {
    return request._post('/shop/plus.bill_rise.Index/add', data);
},
/*修改发票抬头*/
edit(data) {
    return request._post('/shop/plus.bill_rise.Index/edit', data);
},
/*删除发票抬头*/
del(data) {
    return request._post('/shop/plus.bill_rise.Index/del', data);
},
/*发票抬头详情*/
detail(data) {
  return request._post('/shop/plus.bill_rise.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.bill_rise.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.bill_rise.Setting/getSetting', data, errorback);
    },
}
export default Bill_riseApi;



// WEBPACK FOOTER //
// ./src/api/bill_rise.js